module.exports = __webpack_public_path__ + "static/media/valor2_1.bc01f539.png";